import React, { useState, useEffect } from "react";
import { IconButton, Zoom, Box } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!showButton) return null;

  return (
    <Zoom in={showButton}>
      <Box
        sx={{
          position: "fixed",
          bottom: { xs: "20px", sm: "32px" },
          right: { xs: "20px", sm: "32px" },
          zIndex: 999,
        }}
      >
        <IconButton
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          size="large"
          aria-label="scroll to top"
          sx={{
            position: "relative",
            bottom: 0,
            right: 0,
          }}
        >
          <KeyboardArrowUp />
        </IconButton>
      </Box>
    </Zoom>
  );
};

export default ScrollToTop;
